<div class="one" fxLayout="column" [formGroup]="matterAddressForm">
  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-form-field
      appearance="outline"
      fxFlex="33"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.STRATAPLANNUMBER),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.STRATAPLANNUMBER),
      }"
    >
      <mat-label>Strata Plan Number</mat-label>
      <input matInput formControlName="STRATAPLANNUMBER" />
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      fxFlex="34"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.BYLAWTYPE),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.BYLAWTYPE),
      }"
    >
      <mat-label>By Law Type</mat-label>
      <input matInput formControlName="BYLAWTYPE" />
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      fxFlex="33"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.BYLAWNO),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.BYLAWNO),
      }"
    >
      <mat-label>By Law No.</mat-label>
      <input matInput formControlName="BYLAWNO" />
    </mat-form-field>
  </div>
  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-form-field
      appearance="outline"
      class="pr-1"
      fxFlex="33"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.SPECIALRESOLUTIONDATE),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.SPECIALRESOLUTIONDATE),
      }"
    >
      <mat-label>Resolution Date</mat-label>
      <input
        (dateInput)="ResolutionDatepicker('input', $event)"
        (dateChange)="ResolutionDatepicker('change', $event)"
        name="resolutiondatepicker"
        matInput
        [matDatepicker]="resolutiondatepicker"
        formControlName="SPECIALRESOLUTIONDATETEXT"
      />
      <mat-datepicker-toggle matSuffix [for]="resolutiondatepicker"></mat-datepicker-toggle>
      <mat-datepicker #resolutiondatepicker></mat-datepicker>
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      class="pr-1"
      fxFlex="34"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.AGGREGATIONOFENTITLEMENT),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.AGGREGATIONOFENTITLEMENT),
      }"
    >
      <mat-label>Aggr. of Entitlement</mat-label>
      <input matInput formControlName="AGGREGATIONOFENTITLEMENT" />
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      class="pr-1"
      fxFlex="33"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.TOTALUNITS),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.TOTALUNITS),
      }"
    >
      <mat-label>Total Units</mat-label>
      <input matInput formControlName="TOTALUNITS" />
    </mat-form-field>
  </div>
  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-form-field appearance="outline" fxFlex="33" class="pr-1">
      <mat-label>Annual Strata Levies</mat-label>
      <input
        matInput
        style="text-align: right"
        type="text"
        mask="separator.2"
        thousandSeparator=","
        decimalMarker="."
        formControlName="ANNUALSTRATALEVIES"
        [leadZero]="true"
      />
    </mat-form-field>
    <mat-form-field appearance="outline" class="pr-1" fxFlex="33">
      <mat-label>Levies Paid Until</mat-label>
      <input
        (dateInput)="LeviesDatepicker('input', $event)"
        (dateChange)="LeviesDatepicker('change', $event)"
        name="leviesdatepicker"
        matInput
        [matDatepicker]="leviesdatepicker"
        formControlName="STRATALEVIESPAIDUNTILTEXT"
      />
      <mat-datepicker-toggle matSuffix [for]="leviesdatepicker"></mat-datepicker-toggle>
      <mat-datepicker #leviesdatepicker></mat-datepicker>
    </mat-form-field>
  </div>
  <div fxFlex="100">
    <strong>Strata Title Record Holder</strong>
  </div>
  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-form-field appearance="outline" class="pr-1" fxFlex="33">
      <mat-label>Name</mat-label>
      <input matInput formControlName="STRATATITLERECORDHOLDERNAME" />
    </mat-form-field>
    <mat-form-field appearance="outline" class="pr-1" fxFlex="33">
      <mat-label>Email</mat-label>
      <input matInput formControlName="STRATATITLERECORDHOLDEREMAIL" />
    </mat-form-field>
  </div>
  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-form-field appearance="outline" class="pr-1" fxFlex="33">
      <mat-label>Phone</mat-label>
      <input matInput formControlName="STRATATITLERECORDHOLDERPHONE" />
    </mat-form-field>
    <mat-form-field appearance="outline" class="pr-1" fxFlex="33">
      <mat-label>Address</mat-label>
      <input matInput formControlName="STRATATITLERECORDHOLDERADDRESS" />
    </mat-form-field>
  </div>
</div>
